import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ShortCodeMapper } from "../../utils/mappers/operator/shortcode.mapper";
import { ShortCode } from "../../utils/types/shared/shortcode.type";
import { SHORT_CODE_ENDPOINTS } from "../../components/mediaManager/admon/operator/operator-endpoints";
import { Mask } from "../../utils/types/mask/mask.type";

@Injectable()
export class ShortCodeService extends BaseApiService<ShortCode> {
    model = ShortCode;
    mapper = new ShortCodeMapper();
    apiEndPoint: any = SHORT_CODE_ENDPOINTS;

    create(data: ShortCode): Observable<boolean> {
        return this.http.post<boolean>(this.apiEndPoint.base, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    getList(
        filter?: FilterType,
        operatorId?: number
    ): Observable<PagedApiResponse<ShortCode>> {
        return this.http
            .get(this.apiEndPoint.list.replace("{id}", operatorId.toString()))
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    getMask(): Observable<Mask[]> {
        return this.http.get<Mask[]>(this.apiEndPoint.mask);
    }

    update(data: ShortCode): Observable<boolean> {
        const { id } = data;
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, data);
    }

    delete(id: number, companyId?: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item
            .replace("{companyId}", companyId.toString())
            .replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
